<template>
  <div>
    <custom-actions>
      <template #header>
        <el-button type="primary" v-if="hasAdd"
          @click="$router.push('/system/newInvoice/add?sourceType=' + sourceType)">新增</el-button>
        <el-button type="primary" @click="exportLyInvoice">导出</el-button>
      </template>
      <el-form :model="searchForm" ref="formData" inline class="global-form-label-width account-form"
        label-width="100px">
        <el-form-item label="客户名称" prop="userName">
          <el-input clearable v-model="searchForm.userName" placeholder="客户名称" />
        </el-form-item>
        <el-form-item label="发票编码" prop="invoiceId">
          <el-input clearable v-model="searchForm.invoiceId" placeholder="发票编码" />
        </el-form-item>
        <el-form-item label="公司名称" prop='headerName'>
          <el-input clearable v-model="searchForm.headerName" placeholder="公司名称" />
        </el-form-item>
        <el-form-item label="发票状态" prop="invoiceStatus">
          <el-select v-model="searchForm.invoiceStatus" :clearable="true">
            <el-option :label="value" :value="key" v-for="([key, value], index) of Array.from(invoiceStatusMap)"
              :key="index"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSearch">查询</el-button>
          <el-button @click="onReset">重置</el-button>
        </el-form-item>
      </el-form>
    </custom-actions>

    <el-card shadow="never" class="mt10">
      <el-table size="mini" stripe border v-loading="loading" :data="tableData">
        <el-table-column min-width="200" :show-overflow-tooltip="true" label="客户名称" prop="userName"></el-table-column>
        <el-table-column min-width="200" :show-overflow-tooltip="true" label="发票编码" prop="invoiceId"></el-table-column>
        <el-table-column min-width="120" :show-overflow-tooltip="true" label="公司名称" prop="headerName"></el-table-column>
        <el-table-column min-width="120" label="发票来源" prop="sourceType">
          <template v-slot="{ row }">
            {{ invoiceSourceTypeMap.get(row.sourceType) || '-' }}
          </template>
        </el-table-column>
        <el-table-column min-width="200" :show-overflow-tooltip="true" label="抬头名称" prop="headerName"></el-table-column>
        <el-table-column min-width="120" label="发票金额" prop="invoiceAmount"></el-table-column>
        <el-table-column min-width="200" label="发票地址" prop="headerAddress"></el-table-column>
        <el-table-column min-width="120" label="电话" prop="headerPhone"></el-table-column>
        <el-table-column min-width="220" label="税号" prop="taxNumber"></el-table-column>
        <el-table-column min-width="120" :show-overflow-tooltip="true" label="开户行" prop="bankName"></el-table-column>
        <el-table-column min-width="120" :show-overflow-tooltip="true" label="开户行账号"
          prop="bankAccount"></el-table-column>
        <el-table-column min-width="120" label="发票类型" prop="invoiceType">
          <template v-slot="{ row }">
            {{ invoiceTypeMap.get(row.invoiceType) || '-' }}
          </template>
        </el-table-column>
        <el-table-column min-width="120" label="发票状态" prop="invoiceStatus">
          <template v-slot="{ row }">
            <el-tag type="warning" v-if="row.invoiceStatus === '1'">待开票</el-tag>
            <el-tag type="success" v-if="row.invoiceStatus === '2'">已开票</el-tag>
            <el-tag type="danger" v-if="row.invoiceStatus === '3'">已作废</el-tag>
            <el-tag type="info" v-if="row.invoiceStatus === '4'">待作废</el-tag>
          </template>
        </el-table-column>

        <el-table-column width="160" label="操作" fixed="right">
          <template v-slot="{ row }">
            <template>
              <el-button type="text" v-if="hasCancel && row.invoiceStatus === '1'"
                @click="cancelInvoice(row)">取消</el-button>
              <el-button type="text" v-if="hasEdit && row.invoiceStatus === '1'"
                @click="$router.push('/system/newInvoice/edit?invoiceId=' + row.invoiceId + '&sourceType=' + sourceType)">编辑</el-button>
              <el-button type="text"
                @click="$router.push('/system/newInvoice/detail?invoiceId=' + row.invoiceId)">详情</el-button>
            </template>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination class="mt15" :current-page.sync="page" background layout="total, prev, pager, next" :total="total"
        @current-change="loadData">
      </el-pagination>
    </el-card>
  </div>
</template>

<script>
import { invoiceSourceType, invoiceType, invoiceStatus } from '@/utils/dict'
import keepAlive from '@/mixins/keepAlive'
import { getMenuByCode } from '@/utils/utils'
export default {
  name: 'InvoiceManage',
  mixins: [keepAlive],
  data() {
    return {
      invoiceSourceTypeMap: invoiceSourceType,
      invoiceTypeMap: invoiceType,
      invoiceStatusMap: invoiceStatus,
      tableData: [],
      page: 1,
      total: 0,
      loading: false,
      searchForm: {
        invoiceId: '',
        userName: '',
        headerName: '',
        invoiceStatus: ''
      }
    }
  },
  created() {
    this.loadData()
  },
  computed: {
    buttonList() {
      const menu = getMenuByCode(this.$store.state.menus, this.menuCode)
      return (menu.button || []).map(item => item.butCode)
    },
    hasDelete() {
      return this.buttonList.includes('delete')
    },
    hasCancel() {
      return this.buttonList.includes('cancel')
    },
    hasEdit() {
      return this.buttonList.includes('edit')
    },
    hasAdd() {
      return this.buttonList.includes('add')
    },
    sourceType() {
      return this.$route.query.sourceType || 'TH'
    },
    menuCode() {
      if (this.sourceType === 'CY') {
        return 'CYFPGL'
      } else if (this.sourceType === 'TH') {
        return 'FPGLNEW'
      } else if (this.sourceType === 'YC') {
        // return 'YCQRCK'
      }
      return ''
    }
  },
  methods: {
    cancelInvoice(row) {
      this.$confirm('确认取消该发票吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.post(this.$apis.lyInvoice.deleteLyInvoice, {
          invoiceId: row.invoiceId
        }).then(() => {
          this.onSearch()
        })
      })
    },
    exportLyInvoice() {
      const loadingInstance = this.$loading({
        text: '正在导出...',
        background: 'rgba(0, 0, 0, 0.8)'
      })
      this.$axios.post(this.$apis.lyInvoice.exportLyInvoice, this.searchForm, {
        responseType: 'blob'
      }).then(res => {
        if (res) {
          const disposition = res.headers['content-disposition']
          const fileName = disposition.substring(disposition.indexOf('filename')).split('=')[1]
          this.downloadFile(res.data, fileName)
        }
      }).catch(error => {
        console.error('导出失败:', error)
      }).finally(() => {
        loadingInstance.close()
      })
    },
    downloadFile(data, fileName) {
      const blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
      const downloadElement = document.createElement('a')
      // 创建下载的链接
      const href = window.URL.createObjectURL(blob)
      downloadElement.href = href
      // 下载后文件名
      console.log('decodeURIComponent(fileName)', decodeURIComponent(fileName))
      downloadElement.download = decodeURIComponent(fileName)
      document.body.appendChild(downloadElement)
      downloadElement.click()
      document.body.removeChild(downloadElement)
      // 释放掉blob对象
      window.URL.revokeObjectURL(href)
    },
    loadData() {
      this.$axios.get(this.$apis.lyInvoice.selectLyInvoiceByPage, {
        page: this.page,
        size: 10,
        sourceType: this.sourceType,
        ...this.searchForm
      }).then(res => {
        this.tableData = res.list
        this.total = res.total
      })
    },
    onSearch() {
      this.page = 1
      this.loadData()
    },
    onReset() {
      this.$refs.formData.resetFields()
      this.onSearch()
    },
    deleteRow(headerId) {
      this.$confirm('确认删除该记录, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.post(this.$apis.lyInvoice.deleteDataLyInvoiceHeader, {
          headerId
        }).then(() => {
          this.loadData()
        })
      })
    }
  }
}
</script>

<style scoped lang='scss'>
// .el-select {
//   width: 100%;
// }</style>
<style lang='scss'>
.account-form {

  .el-select,
  .el-input,
  .el-cascader {
    width: 200px !important;
  }
}
</style>
